import ConfigurationManager from '../_configuration/ConfigurationManager';
import HttpMethod from '../_utils/HttpMethod';
import URIBuilder from '../_utils/URIBuilder';

const USER_METADATA_ENRICH_PATH = '/user/enrich-licensee-creation-metadata';
const USER_PROVISION_PATH = '/user/provision-user';

class UtilitiesClient {
    enrichMetadata(body, accessToken) {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('X-Api-Key', ConfigurationManager.getProperty('UTILITIES_API_X_API_KEY'));
        headers.append('access_token', accessToken);

        let configuration = {};
        configuration.method = HttpMethod.POST;
        configuration.headers = headers;
        configuration.body = JSON.stringify(body);

        let uri = new URIBuilder(ConfigurationManager.getProperty('UTILITIES_API_HOST'));
        uri.path = `${ConfigurationManager.getProperty('UTILITIES_API_BASE_PATH')}${USER_METADATA_ENRICH_PATH}`;

        let request = new Request(uri.toString(), configuration);
        return fetch(request).then(res => res.json());
    }

    provisionUser(body, accessToken) {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        headers.append('X-Api-Key', ConfigurationManager.getProperty('UTILITIES_API_X_API_KEY'));
        headers.append('access_token', accessToken);

        let configuration = {};
        configuration.method = HttpMethod.POST;
        configuration.headers = headers;
        configuration.body = JSON.stringify(body);

        let uri = new URIBuilder(ConfigurationManager.getProperty('UTILITIES_API_HOST'));
        uri.path = `${ConfigurationManager.getProperty('UTILITIES_API_BASE_PATH')}${USER_PROVISION_PATH}`;

        let request = new Request(uri.toString(), configuration);
        return fetch(request).then(res => res.json());
    }
}

export default UtilitiesClient;


// WEBPACK FOOTER //
// ./src/_clients/UtilitiesClient.js